var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contact" }, [
    _c("div", { staticClass: "contact__image-wrapper" }, [
      _vm.image
        ? _c("img", {
            staticClass: "contact__image",
            attrs: { src: _vm.image, alt: _vm.title },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "contact__image-icon" }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "contact__info" }, [
      _c("h2", { staticClass: "contact__name" }, [
        _vm._v("\n            " + _vm._s(_vm.title) + "\n        "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "contact__desc" }, [
        _vm._v("\n            " + _vm._s(_vm.desc) + "\n        "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contact__connections" },
        _vm._l(_vm.contacts, function (contact, id) {
          return _c(
            "div",
            { key: id, staticClass: "contact__connection connection" },
            [
              _c("p", { staticClass: "connection__name" }, [
                _vm._v(_vm._s(contact.typeName)),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "connection__item-container" },
                [
                  _vm._l(contact.items, function (contactItem, idx) {
                    return [
                      !contactItem.link
                        ? _c(
                            "div",
                            { key: idx, staticClass: "connection__item" },
                            [
                              _c("z-icon", {
                                staticClass: "connection__icon",
                                attrs: {
                                  name: contactItem.type,
                                  dir: "top",
                                  width: "24",
                                  height: "24",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "connection__value" }, [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(contactItem.value) +
                                    "\n                                    "
                                ),
                              ]),
                            ],
                            1
                          )
                        : _c(
                            "a",
                            {
                              key: idx,
                              staticClass: "connection__item",
                              attrs: { href: contactItem.link },
                            },
                            [
                              _c("z-icon", {
                                staticClass: "connection__icon",
                                attrs: {
                                  name: contactItem.type,
                                  dir: "top",
                                  width: "24",
                                  height: "24",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "connection__value" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(contactItem.value) +
                                    "\n                                "
                                ),
                              ]),
                            ],
                            1
                          ),
                    ]
                  }),
                ],
                2
              ),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }